export default __webpack_public_path__ + "static/media/twitter-logo.64921262.png";